module.exports = "<p>\n  component works!\n</p>\n"